import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "settings-frame" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "right"
}
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.title || _ctx.$slots.description || $props.description || _ctx.$slots.right)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString($props.title) + " ", 1 /* TEXT */),
            (_ctx.$slots.right)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "right", {}, undefined, true)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.$slots.description)
              ? _renderSlot(_ctx.$slots, "description", { key: 0 }, undefined, true)
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.description), 1 /* TEXT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}